import { inject, Injectable } from '@angular/core';
import { HttpInterceptor, HttpRequest, HttpHandler, HttpEvent, HttpErrorResponse } from '@angular/common/http';
import { catchError, Observable, throwError } from 'rxjs';
import { OAuthService } from 'angular-oauth2-oidc';
import { Router } from '@angular/router';
import { USER_SECURITY_INFO_KEY } from 'services/authorization.service';

export const UNAUTHORIZED_ERROR_CODE = 401;

@Injectable()
export class AuthInterceptor implements HttpInterceptor {
  constructor(
    private router: Router,
    private oauthService: OAuthService
  ) {}

  intercept(request: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
    const oauthService = inject(OAuthService);

    if (oauthService.hasValidAccessToken()) {
      const clonedRequest = request.clone({
        headers: request.headers.set('Authorization', `Bearer ${oauthService.getAccessToken()}`)
      });
      return next.handle(clonedRequest).pipe(
        catchError((error: HttpErrorResponse) => {
          if (error.status === UNAUTHORIZED_ERROR_CODE) {
            localStorage.removeItem(USER_SECURITY_INFO_KEY);
            this.oauthService.revokeTokenAndLogout(true);
            this.router.navigate(['/login']);
          }
          return throwError(() => error);
        })
      );
    }

    return next.handle(request);
  }
}
